// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Checkbox } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import SpringModal from "examples/Modal";

// Data
import tradersTableData from "layouts/table_traders/data/tradersTableData";
import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useMaterialUIController, fetchTraders } from "context";
import { fetchStatus } from "context";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function TableTraders() {
  const [controller, dispatch] = useMaterialUIController();

  const { status } = controller;

  const [modalDelete, setModalDelete] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [trader, setTrader] = useState(null);
  const [dataForm, setDataForm] = useState({
    name: "",
    lastName: "",
    phone: "",
    status: "",
  });
  const [selectedExportIds, setSelectedExportIds] = useState([]);

  useEffect(() => {
    fetchStatus(dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (trader) {
      setDataForm({
        name: trader?.persons?.name,
        lastName: trader?.persons?.lastname,
        phone: trader?.persons?.phone_number,
        status: trader?.status.id,
      });
    }
  }, [trader]);

  const token = Cookies.get("access_token");

  const handleDisableClick = (value) => {
    if (trader?.status.name !== "Activo") return;
    setTrader(value);
    setModalDelete(true);
  };

  const handleEditClick = (value) => {
    setTrader(value);

    const selectedStatus = status?.data?.find((status) => status.name === trader?.status?.name);

    setDataForm({
      name: trader?.persons?.name,
      lastName: trader?.persons?.lastname,
      phone: trader?.persons?.phone_number,
      status: selectedStatus ? selectedStatus.id : "",
    });

    setModalEdit(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;

    setDataForm((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleModalClose = () => {
    setModalDelete(false);
    setModalEdit(false);
  };

  const confirmDelete = async () => {
    try {
      const response = await axios.delete(`/admin/traders/${trader?.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      fetchUsers(dispatch);
      setModalDelete(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.put(
        `/admin/traders/${trader.id}`,
        {
          telegram_id: trader?.telegram_id,
          username: trader?.username,
          origen: trader?.origin,
          name: dataForm.name,
          subscription_id: trader?.Subscriptions?.id,
          lastname: dataForm.lastName,
          phone_number: dataForm.phone,
          status_id: dataForm.status,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        fetchTraders(dispatch);
        handleModalClose();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Elimina el select de exportación y agrega manejo de checks
  const handleCheckRow = (id) => {
    setSelectedExportIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const { columns, rows } = tradersTableData({
    handleDisableClick,
    handleEditClick,
    selectedIds: selectedExportIds,
    onCheckRow: handleCheckRow,
  });

  // Filtrar los rows según los checks activos para exportar
  const getExportRows = () => {
    if (!rows || !Array.isArray(rows)) return [];
    if (!selectedExportIds.length) return rows;
    return rows.filter((row) => selectedExportIds.includes(row.id));
  };

  function exportToExcel(columns, rows) {
    // Definir el orden y los headers manualmente
    const headers = [
      "id",
      "Telegram id",
      "usuario",
      "name",
      "lastname",
      "email",
      "teléfono",
      "status",
    ];
    const exportRows = getExportRows();
    const data = exportRows.map((row) => [
      row.id,
      row.telegram_id,
      row.user,
      row.name,
      row.lastname,
      row.email,
      row.phone,
      row.status,
    ]);
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Traders");
    XLSX.writeFile(workbook, "traders.xlsx");
  }

  function exportToPDF(columns, rows) {
    const doc = new jsPDF();
    const headers = columns
      .filter((col) => col.accessor && col.accessor !== "actions")
      .map((col) => col.Header);
    const exportRows = getExportRows();
    const data = exportRows.map((row) =>
      columns
        .filter((col) => col.accessor && col.accessor !== "actions")
        .map((col) => {
          if (col.accessor === "searchableData") {
            return `${row.name || ""} ${row.lastname || ""} ${row.email || ""}`.trim();
          }
          return row[col.accessor];
        })
    );
    autoTable(doc, { head: [headers], body: data });
    doc.save("traders.pdf");
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Traders
                </MDTypography>
                <MDBox display="flex" alignItems="center" gap={2}>
                  <MDButton
                    variant="gradient"
                    color="success"
                    onClick={() => exportToExcel(columns, rows)}
                    sx={{ mr: 1 }}
                  >
                    Exportar Excel
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color="error"
                    onClick={() => exportToPDF(columns, rows)}
                  >
                    Exportar PDF
                  </MDButton>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={{ defaultValue: 10, entries: [10, 15, 20, 25] }}
                  showTotalEntries={false}
                  noEndBorder
                  pagination={{ variant: "gradient", color: "info" }}
                  canSearch={true}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <SpringModal open={modalDelete} onClose={handleModalClose}>
        <MDTypography variant="h6" component="h2" textAlign={"center"}>
          ¿Estás seguro de que quieres deshabilitar al usuario {trader?.username}?
        </MDTypography>

        <MDBox display={"flex"} justifyContent={"center"} sx={{ mt: 4 }}>
          <MDButton variant="gradient" color="secondary" onClick={confirmDelete}>
            Confirmar
          </MDButton>

          <MDButton variant="gradient" color="primary" onClick={handleModalClose} sx={{ ml: 2 }}>
            Cancelar
          </MDButton>
        </MDBox>
      </SpringModal>

      <SpringModal open={modalEdit} onClose={handleModalClose}>
        <MDBox mb={2}>
          <MDInput
            type="email"
            value={trader?.username}
            placeholder="Usuario"
            label="Usuario"
            fullWidth
            disabled
          />
        </MDBox>

        <MDBox mb={2}>
          <MDInput
            type="email"
            name="email"
            value={trader?.persons?.email}
            placeholder="Correo Electrónico"
            label="Correo Electrónico"
            fullWidth
            disabled
          />
        </MDBox>

        <MDBox display="flex" gap={2} mb={2}>
          <MDInput
            label="Nombre"
            placeholder="Nombre"
            name="name"
            type="text"
            value={dataForm.name}
            onChange={handleFormChange}
            fullWidth
            requiered
          />

          <MDInput
            label="Apellido"
            placeholder="Apellido"
            type="text"
            name="lastName"
            value={dataForm.lastName}
            onChange={handleFormChange}
            fullWidth
            requiered
          />
        </MDBox>

        <MDBox mb={2}>
          <MDInput
            label="Teléfono"
            placeholder="Teléfono"
            type="text"
            name="phone"
            value={dataForm.phone}
            onChange={handleFormChange}
            fullWidth
            requiered
          />
        </MDBox>

        <MDBox display={"flex"} justifyContent={"center"} sx={{ mt: 4 }}>
          <MDButton variant="gradient" color="secondary" onClick={handleSubmit}>
            Guardar
          </MDButton>

          <MDButton variant="gradient" color="primary" onClick={handleModalClose} sx={{ ml: 2 }}>
            Cancelar
          </MDButton>
        </MDBox>
      </SpringModal>
    </DashboardLayout>
  );
}

export default TableTraders;
